const eventsGridNames = {
	cardClick: 'click-bot-in-grid',
	viewGrid: 'view-grid',
	filterSubmitted: 'view-grid-filters',
};

export default eventsGridNames;
